/* eslint-disable */
import { get, shuffle } from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import collapsiblePanel from '@/components/collapsible-panel/collapsible-panel.vue';
import twitter from '@/components/twitter/twitter';
import { MODALS } from '@/components/app/app-modals/app-modals';
import accountLogin from '@/components/cms/account-combined-login/account-combined-login.vue';
import marketListItemEmbed from '@/components/cms/market-list-item-v2-embed/market-list-item-v2-embed.vue';
import marketContractListEmbed from '@/components/cms/market-contract-list-v2-embed/market-contract-list-v2-embed.vue';
import linkComponent from '@/components/generics/link/link.vue';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import podcastsComponent, { PODCAST } from '@/components/home/home-old/podcasts/podcasts.vue';
import store from '@/store';

const LoginComponent = Vue.extend(accountLogin);
const CollapsiblePanelComponent = Vue.extend(collapsiblePanel);
const MarketListItemEmbedComponent = Vue.extend(marketListItemEmbed);
const MarketContractListEmbedComponent = Vue.extend(marketContractListEmbed);
const LinkComponent = Vue.extend(linkComponent);
const PodcastsComponent = Vue.extend(podcastsComponent);
const MarketChartsComponent = Vue.extend(marketCharts);

const dateGoDisplay = (dt) => {
  const daysDiff = moment().diff(dt, 'days');
  const hoursDiff = moment().diff(dt, 'hours');
  if (daysDiff > 365) {
    const years = Math.floor(daysDiff / 365);
    return (years === 1) ? '1 year ago' : `${years} years ago`;
  } else if (daysDiff > 30) {
    const months = Math.floor(daysDiff / 30);
    return (months === 1) ? '1 month ago' : `${months} months ago`;
  } else if (hoursDiff > 24) {
    return (daysDiff === 1) ? '1 day ago' : `${daysDiff} days ago`;
  } else if (hoursDiff >= 1) {
    return (hoursDiff === 1) ? '1 hour ago' : `${Math.floor(hoursDiff)} hours ago`;
  }
  return 'Within the last hour';
};

export default {
  data() {
    return {
      content: '',
      marketTileMarkets: [],
      contractListMarkets: [],
      cmsAccordionContentObjects: [],
      podcastItemContentObjects: [],
      chartWidgetObjects: [],
    };
  },
  methods: {
    installAccordions() {
      const accordionHeaders = this.$el.querySelectorAll('.predictit__accordion');
      for (const el of accordionHeaders) {
        const index = parseInt(el.getAttribute('data-accordionindex'), 10);
        const title = el.getAttribute('data-accordiontitle');
        const accordionObj = this.cmsAccordionContentObjects.find(i => i.accordionIndex === index);

        if (accordionObj) {
          const content = accordionObj.content || '';
          const instance = new CollapsiblePanelComponent({
            parent: this,
            propsData: {
              title,
              content,
              isOpen: accordionObj.isOpenByDefault,
            },
          });
          instance.$mount(el);
        }
      }
    },
    installTweets() {
      twitter().ready((twt) => {
        const twitterWidgets = this.$el.querySelectorAll('.predictit__twitter');
        for (const widget of twitterWidgets) {
          const tweetId = widget.getAttribute('data-tweetid');
          twt.widgets.createTweet(
            tweetId,
            widget,
            {
              theme: 'light',
            },
          );
        }
      });
    },
    installDateElapsed() {
      const dateEls = this.$el.querySelectorAll('.predictit__elapsedtime');
      for (const el of dateEls) {
        const date = moment(el.getAttribute('data-publishdate'));
        el.innerHTML = dateGoDisplay(date);
      }
    },
    installLoginAndSignUpControls() {
      const loginButtons = this.$el.querySelectorAll('.predictit-login-button');
      for (const button of loginButtons) {
        button.addEventListener('click', () => {
          this.setCurrentPopup(MODALS.LOGIN);
        });
      }
      const loginControls = this.$el.querySelectorAll('.predictit-login-control');
      for (const button of loginControls) {
        const instance = new LoginComponent({
          parent: this,
          propsData: {},
        });
        instance.$mount(button);
      }

      const signUpButtons = this.$el.querySelectorAll('.predictit-signup-button');
      for (const button of signUpButtons) {
        button.addEventListener('click', () => {
          this.setCurrentPopup(MODALS.REGISTER);
        });
      }
    },
    installMarketLists() {
      const marketListEls = this.$el.querySelectorAll('.predictit__markettilelist');

      for (const el of marketListEls) {
        const marketIds = el.getAttribute('data-marketids').replace(' ', '').split(',').map(i => parseInt(i, 10));
        const markets = marketIds
          .map(marketId => this.marketTileMarkets.find(i => i.marketId === marketId))
          .filter(i => !!i);

        if (markets.length > 0) {
          const instance = new MarketListItemEmbedComponent({
            parent: this,
            propsData: {
              markets,
            },
          });
          instance.$mount(el);
        }
      }
    },
    installMarketContracts() {
      const marketContractsEl = this.$el.querySelectorAll('.predictit__marketpreview');
      for (const el of marketContractsEl) {
        const marketId = parseInt(el.getAttribute('data-marketid'), 10);
        const market = this.contractListMarkets.find(i => i.marketId === marketId);
        if (market) {
          const contractIds = el.getAttribute('data-contractids').replace(' ', '').split(',').map(i => parseInt(i, 10));
          const contracts = market.contracts.filter(i => contractIds.includes(i.contractId));
          const instance = new MarketContractListEmbedComponent({
            parent: this,
            propsData: {
              market: {
                ...market,
                contracts: [...contracts],
              },
            },
          });
          instance.$mount(el);
        }
      }
    },
    installButtonsAndLinks() {
      const links = this.$el.querySelectorAll('[data-buttontype="Link"]');
      for (const el of links) {
        const url = el.getAttribute('data-detailpath');
        const instance = new LinkComponent({
          parent: this,
          propsData: {
            type: 'link',
            text: el.innerHTML,
            url,
          },
        });
        instance.$mount(el);
      }

      const buttons = this.$el.querySelectorAll('[data-buttontype="Button"]');
      for (const el of buttons) {
        const url = el.getAttribute('data-detailpath');
        const instance = new LinkComponent({
          parent: this,
          propsData: {
            type: 'button',
            text: el.innerHTML,
            url,
          },
        });
        instance.$mount(el);
      }
    },
    installPodcasts() {
      const podcastSliders = this.$el.querySelectorAll('.predictit__podcastslider');
      for (const el of podcastSliders) {
        const podcastIndexes = el.getAttribute('data-podcastids').replace(' ', '').split(',').map(i => parseInt(i, 10));
        const podcasts = podcastIndexes.map(index => this.podcastItemContentObjects.find(podcast => podcast.podcastIndex === index));
        const title = el.getAttribute('data-podcasttitle');
        const isRandomized = el.getAttribute('data-podcastisrandomized');
        let items = podcasts.map((i) => {
          const chunks = i.podcastUrl.split('/');
          return {
            id: chunks[chunks.length - 1],
            type: PODCAST.APPLE,
          };
        });

        if (isRandomized === 'True') {
          items = shuffle(items);
        }
        const instance = new PodcastsComponent({
          parent: this,
          propsData: {
            theme: 'story',
            title,
            items,
          },
        });
        instance.$mount(el);
      }
    },
    installMarketCharts() {
      const marketChartsEl = this.$el.querySelectorAll('.predictit__datachart');
      for (const el of marketChartsEl) {
        const index = parseInt(el.getAttribute('data-chartindex'), 10);
        const versionId = el.getAttribute('data-chartstoryversionid');
        const storyId = el.getAttribute('data-chartstoryid');

        const chartObj = this.chartWidgetObjects.find(i => i.chartIndex === index);
        store.dispatch('market/getMarket', { marketId: chartObj.marketId, modifyState: false })
          .then((market) => {
            let result = {...market};
            if (chartObj.contractIds) {
              result = {
                ...result,
                contracts: result.contracts.filter(i => chartObj.contractIds.includes(i.contractId)),
              };
            }
            const instance = new MarketChartsComponent({
              parent: this,
              propsData: {
                market: result,
                chartOptions: {
                  ...chartObj,
                  cmsStoryId: storyId,
                  cmsVersionId: versionId,
                  includeDownload: false,
                  // showContractImagesOnLegend: true,
                  // showContractImagesOnChart: true,
                },
              },
            });
            instance.$mount(el);
          })
      }
    },
    installDynamicControls({ data = {} } = {}) {
      this.content = get(data, 'renderedHTML', '');
      this.cmsAccordionContentObjects = get(data, 'cmsContentObject.accordionContentObjects', []);
      this.podcastItemContentObjects = get(data, 'cmsContentObject.podcastItemContentObjects', []);
      this.contractListMarkets = get(data, 'cmsContentObject.contractListMarkets', []);
      this.marketTileMarkets = get(data, 'cmsContentObject.marketTileMarkets', []);
      this.chartWidgetObjects = get(data, 'cmsContentObject.chartWidgetObjects', []);

      this.$nextTick(() => {
        this.installAccordions();
        this.installTweets();
        this.installDateElapsed();
        this.installLoginAndSignUpControls();
        this.installMarketLists();
        this.installMarketContracts();
        this.installButtonsAndLinks();
        this.installPodcasts();
        this.installMarketCharts();
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/cmsContent.js